import ChatBox from "./components/ChatBox";
import "./App.css";

function App() {
  return (
    <div className="App">
      <ChatBox />
    </div>
  );
}

export default App;